<template>
  <div>
    <!-- NUMBER -->
    <input type="text" :name="fieldValueInputName" :id="pFieldValueInputId"
           class="form-control" v-model="value" size="50" maxlength="100" :readonly="fieldValueInputReadonly"/>
  </div>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";

export default {
  name: "FieldValueNumberForm",
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pFieldValue: {
      type: Object,
      required: true
    },
    pFieldValueInputId: {
      type: String,
      required: true
    },
    pFieldValueInputNamePrefix: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      value: this.pFieldValue.value
    }
  },
  computed: {
    fieldValueInputName: function() {
      return this.pFieldValueInputNamePrefix + ".value";
    },
    fieldValueInputReadonly: function() {
      return this.pFieldValue.generated;
    },
  }
}
</script>

<style scoped>

</style>